module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-64-active.01abce3b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-leaderboards-64-active.png
// module id = 3198
// module chunks = 11